<template>
	<div class="side-nav-container">
		<router-link
			:class="
				'menu-item ' +
					(item.to && item.to.indexOf(routerName) > -1 ? 'active-class' : '') +
					(item.children ? 'has-children' : '')
			"
			:key="item.name"
			v-for="item in routers"
			:to="item.to || ''"
			active-class="active-class"
		>
			<div class="parent-item">
				<span :class="item.icon + ' icon'"></span>
				<span class="name">{{ item.name }}</span>
			</div>
			<router-link
				v-for="(subItem, index) in item.children"
                :key="index"
				class="sub-item"
				:to="subItem.to || ''"
				active-class="active-class"
			>
				<span :class="subItem.icon + ' icon sub-icon'"></span>
				<span class="name">{{ subItem.name }}</span>
			</router-link>
		</router-link>
	</div>
</template>

<script>
	export default {
		components: {},

		watch: {
			$route(to, pre) {
				this.routerName = to.query.currentRoute;
			},
		},
		data() {
			return {
				routerName: this.$router.currentRoute.query.currentRoute,
				routers: [
					{ to: "/service-center/all", name: "首页", icon: "one-home" },
					{
						to: "/service-center/prodbook",
						name: "产品手册",
						icon: "one-legal-finance-regulations",
					},
					{
						to: "/service-center/entcourse",
						name: "对企课程",
						icon: "one-live",
					},
					{
						to: "/service-center/corporate-template-course",
						name: "服务模板",
						icon: "one-counsel-service",
					},
					{
						to: "/service-center/skill-course",
						name: "技能课程",
						icon: "one-performance",
					},
					// {
					// 	to: "/service-center/online-course",
					// 	name: "其他课程",
					// 	icon: "one-moreapp",
					// },
					// {
					// 	to: "",
					// 	name: "全面体检",
					// 	icon: "one-notebook",
					// 	children: [
					// 		{
					// 			name: "法治体检",
					// 			to: "/service-center/law-exam",
					// 			icon: "one-dot",
					// 		},
					// 		{
					// 			name: "劳动人事专项体检",
					// 			to: "/service-center/labor-exam",
					// 			icon: "one-dot",
					// 		},
					// 	],
					// },
				],
			};
		},
	};
</script>

<style scoped lang="scss">
	.side-nav-container {
		position: sticky;
		top: 20px;
		height: 100vh;
	}

	.menu-item {
		display: block;
		width: 56px;
		min-height: 30px;
		line-height: 30px;
		margin: 18px 0px;
		text-decoration: none;
		white-space: nowrap;
		color: #333333;

		.sub-item {
			display: block;

			.icon {
				margin-left: 22px;
				font-size: 12px;
				margin-right: 4px;
			}
			.name {
				margin-left: 2px;
			}

			&.active-class {
				color: #ed6c00;

				.icon.sub-icon {
					color: #ed6c00 !important;
				}
			}
		}
	}

	.menu-item:hover,
	.active-class {
		color: #ed6c00;

		.sub-item {
			color: #333333;

			.icon {
				color: #b1b1b1 !important;
			}
		}

		.icon {
			color: #ed6c00 !important;
		}

		&.has-children {
			color: #333333;

			.icon {
				color: #b1b1b1 !important;
			}
		}
	}

	.menu-item .sub-item:hover {
		color: #ed6c00;

		.icon {
			color: #ed6c00 !important;
		}
	}

	.menu-item .icon {
		display: inline-block;
		width: 20px;
		height: 20px;
		margin-left: 18px;
		margin-right: 8px;
		font-family: icon-one;
		position: relative;
		top: -2px;
		color: #b1b1b1;
		font-size: 18px;
		vertical-align: middle;
	}

	.menu-item .name {
		display: inline-block;
		width: 56px;
		height: 24px;
		font-weight: 600;
		font-size: 14px;
		vertical-align: middle;
		font-family: PingFangSC;
	}
</style>
